import React from 'react';
import unassignedAppsError from '../../assets/images/unassignedAppsError.png';
import '../DefaultOktaError/style.scss';
const UnassignedTapApps = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Unassigned tap apps",
    src: unassignedAppsError
  }), /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, __("Unassigned TAP apps in okta")), /*#__PURE__*/React.createElement("div", {
    className: "subHeading"
  }, __("Snap! Looks like you don't have access to Stage TAP yet.")), /*#__PURE__*/React.createElement("div", null, __(" Please write to "), /*#__PURE__*/React.createElement("a", {
    href: "mailto:helpdesk@tekion.com"
  }, "helpdesk@tekion.com"), __(" to enable access.")));
};
export default UnassignedTapApps;